import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "pos-panel" }
const _hoisted_2 = {
  key: 0,
  class: "pos-loading"
}
const _hoisted_3 = {
  key: 1,
  class: "pos-error"
}
const _hoisted_4 = { class: "pos-header" }
const _hoisted_5 = { class: "pos-title" }
const _hoisted_6 = { class: "pos-meta" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 0,
  class: "pos-desc"
}
const _hoisted_9 = {
  key: 0,
  class: "pos-empty"
}
const _hoisted_10 = {
  key: 1,
  class: "pos-items"
}
const _hoisted_11 = { class: "pos-item-title" }
const _hoisted_12 = {
  key: 0,
  class: "pos-item-desc"
}
const _hoisted_13 = ["onUpdate:modelValue"]
const _hoisted_14 = { class: "pos-check-row" }
const _hoisted_15 = ["onUpdate:modelValue"]
const _hoisted_16 = ["onChange"]
const _hoisted_17 = {
  key: 2,
  class: "pos-error"
}
const _hoisted_18 = { class: "pos-actions" }
const _hoisted_19 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "pos-back",
      type: "button",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
    }, [...(_cache[2] || (_cache[2] = [
      _createElementVNode("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "2"
      }, [
        _createElementVNode("polyline", { points: "15 18 9 12 15 6" })
      ], -1),
      _createTextVNode(" Voltar ", -1)
    ]))]),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Carregando..."))
      : (_ctx.loadError)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.loadError), 1))
        : (_ctx.os)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, "OS" + _toDisplayString(_ctx.os.osNumber) + " — " + _toDisplayString(_ctx.os.title), 1),
                _createElementVNode("div", _hoisted_6, [
                  _createTextVNode(_toDisplayString(_ctx.os.projectName) + " · " + _toDisplayString(_ctx.os.responsaveis.join(', ')) + " ", 1),
                  (_ctx.os.dueDate)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, " · prazo " + _toDisplayString(_ctx.formatDate(_ctx.os.dueDate)), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", {
                    class: _normalizeClass(["pos-priority-badge", 'p-' + _ctx.os.priority])
                  }, _toDisplayString(_ctx.priorityLabel(_ctx.os.priority)), 3)
                ]),
                (_ctx.os.description)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.os.description), 1))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.pendingItems.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, "Todas as rotinas desta OS já foram preenchidas."))
                : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pendingItems, (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: item.id,
                        class: "pos-item"
                      }, [
                        _createElementVNode("div", _hoisted_11, _toDisplayString(item.title), 1),
                        (item.description)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(item.description), 1))
                          : _createCommentVNode("", true),
                        _withDirectives(_createElementVNode("textarea", {
                          class: "pos-textarea",
                          "onUpdate:modelValue": ($event: any) => ((_ctx.evidenceFor(item.id).textResponse) = $event),
                          rows: "2",
                          placeholder: "Descreva o que foi feito (opcional)"
                        }, null, 8, _hoisted_13), [
                          [_vModelText, _ctx.evidenceFor(item.id).textResponse]
                        ]),
                        _createElementVNode("label", _hoisted_14, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            "onUpdate:modelValue": ($event: any) => ((_ctx.evidenceFor(item.id).checkResponse) = $event)
                          }, null, 8, _hoisted_15), [
                            [_vModelCheckbox, _ctx.evidenceFor(item.id).checkResponse]
                          ]),
                          _cache[3] || (_cache[3] = _createTextVNode(" Marcar como concluído ", -1))
                        ]),
                        _createElementVNode("input", {
                          type: "file",
                          accept: "image/*",
                          onChange: ($event: any) => (_ctx.onPhotoSelected($event, item.id))
                        }, null, 40, _hoisted_16)
                      ]))
                    }), 128))
                  ])),
              (_ctx.submitError)
                ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(_ctx.submitError), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_18, [
                (_ctx.pendingItems.length > 0)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "pos-btn pos-btn-primary",
                      type: "button",
                      disabled: _ctx.saving,
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.submitAll && _ctx.submitAll(...args)))
                    }, _toDisplayString(_ctx.saving ? 'Enviando...' : `Confirmar conclusão (${_ctx.pendingItems.length} ${_ctx.pendingItems.length > 1 ? 'itens' : 'item'})`), 9, _hoisted_19))
                  : _createCommentVNode("", true)
              ])
            ], 64))
          : _createCommentVNode("", true)
  ]))
}